import { connect } from 'react-redux'
import TileInfoPopoverContent from 'components/tiled-menu/TileInfoPopoverContent'

const mapStateToProps = state => ({
  controller: state.layout.controller
})

export default connect(mapStateToProps, null)(TileInfoPopoverContent)
